<template>
  <div class="two-banner">
    <div class="two-banner-item" v-for="(item, index) in twoColumnList" :key="index">
      <img class="img-cover" :src="isMobile ? item.mobileImg : item.img" :alt="item.name" />
      <div class="banner-text fade-up">
        <h3 class="banner-name">{{ item.name }}</h3>
        <p class="banner-desc">{{ item.desc }}</p>
        <ul class="txt-list">
          <li v-for="(item, index) in item.txtList" :key="index">{{ item }}</li>
        </ul>
        <p class="banner-price">{{ item.price }}</p>
      </div>
      <div class="banner-link fade-up">
        <button @click.stop="toggleQr(index)">即刻下订 →</button>
        <!-- 二维码 -->
        <div class="qr-code-box" v-show="activeQrIndex === index" @click.stop>
          <p class="qr-code-txt">即刻下订</p>
          <img class="qr-code-img" :src="item.link" alt="二维码" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarBannerTwoColumn',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    twoColumnList: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      imgUrlPrefix: '/assets/images/badainJaran/', 
      bannerUrl: this.imgUrlPrefix + 'banner.png',
      activeQrIndex: -1,
    }
  },
  methods: {
    // 切换指定索引的二维码显示状态
    toggleQr(index) {
      // 如果点击的是当前已打开的，则关闭；否则打开新的
      if (this.activeQrIndex === index) {
        this.activeQrIndex = -1;
      } else {
        this.activeQrIndex = index;
      }
    },
    // 关闭所有二维码
    closeAllQr() {
      this.activeQrIndex = -1;
    }
  },
}
</script>

<style lang="less" scoped>
.two-banner {
  width: 100%;
  aspect-ratio: 1920 / 971;
  display: flex;
  font-family: 'TsangerYunHei', sans-serif;
  .two-banner-item {
    width: 50%;
    flex: 1;
    height: 100%;
    position: relative;
    .banner-text {
      position: absolute;
      left: 4.88vw;
      right: 2.44vw;
      top: 4.17vw;
      font-family: 'TsangerYunHei', sans-serif;
      .banner-name {
        font-size: clamp(38px, 2.5vw, 48px);
        color: #181414;
        font-weight: @fw2;
      }
      .banner-desc {
        font-size: clamp(16px, 1.25vw, 24px);
        line-height: 1.4;
        color: #000;
        margin-top: 0.83vw;
        font-weight: @fw2;
      }
      .txt-list {
        font-size: clamp(14px, 1.04vw, 20px);
        margin-top: 0.83vw;
        color: #000;
        li {
          list-style: inside;
          font-weight: @fw2;
        }
      }
      .banner-price {
        color: #000;
        font-size: clamp(18px, 1.67vw, 32px);
        margin-top: 0.83vw;
      }
    }
    .banner-link {
      position: absolute;
      left: 4.88vw;
      bottom: 6.25vw;
      position: relative;
      button {
        border: 1px solid rgba(0, 0, 0, 0.2);
        color: #222222;
        padding: 10px 20px;
        font-size: 16px;
        font-size: clamp(12px, 0.83vw, 16px);
        font-weight: @fw2;
      }

      // 新增/修改：二维码弹窗样式
      .qr-code-box {
        position: absolute;
        bottom: 130%; // 位于按钮上方
        left: 0;
        
        background: #fff;
        padding: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 20;
        min-width: 120px;
        
        // 小三角指示器
        &::after {
          content: '';
          position: absolute;
          top: 100%;
          left: 20px;
          border-width: 6px;
          border-style: solid;
          border-color: #fff transparent transparent transparent;
        }

        .qr-code-txt {
          font-size: 12px;
          color: #333;
          margin-bottom: 8px;
          font-weight: @fw2;
          white-space: nowrap;
        }

        .qr-code-img {
          width: 125px;
          height: 125px;
          display: block;
          object-fit: contain;
        }
      }

    }
  }
}
@media (max-width: @mobile-width) {
  .two-banner {
    display: flex;
    flex-direction: column;
    padding: 5.33vw;
    gap: 5.33vw;
    aspect-ratio: auto;
    .two-banner-item {
      width: 100%;
      height: auto;
      .banner-text {
        left: 5.33vw;
        right: 5.33vw;
        top: 5.33vw;
        .banner-name {
          font-size: 4.26vw;
          font-weight: @fw1;
        }
        .banner-desc {
          font-size: 6.4vw;
          font-weight: @fw2;
        }
        .txt-list {
          font-size: 3.2vw;
        }
        .banner-price {
          font-size: 4.8vw;
        }
      }
      .banner-link {
        position: absolute;
        left: 6.67vw;
        bottom: 8.53vw;
        position: absolute;
        // 移动端二维码适配
        .qr-code-box {
          left: 0;
          
          &::after {
            left: 20px;
          }

          .qr-code-txt {
            font-size: 3.5vw;
          }
          
          .qr-code-img {
            width: 40vw;
            height: 40vw;
            max-width: fit-content;
          }
        }
      }
    }
  }
}
</style>